<template>
  <BaseLocaleLink
    :to="`/marketplace/products/${product.id}`"
    class="hover:opacity-90"
  >
    <div
      class="rounded-xl overflow-hidden h-full min-h-[200px] bg-center bg-cover"
      :style="{
        backgroundImage: `url(${(product.preview as any).original_url})`,
      }"
    >
      <div class="bg-black/60 w-full h-full p-5 flex flex-col gap-2">
        <div>
          <h2 class="text-xl font-bold uppercase text-white">
            {{ title }}
          </h2>
          <div class="text-white text-md leading-tight mt-1">
            {{ shortDescription }}
          </div>
        </div>
        <div v-if="product.entity?.entity_id" class="text-white mt-auto">
          <div class="flex items-center gap-2">
            <img
              v-if="product.entity?.entity_media"
              loading="lazy"
              class="w-5 h-5 rounded-[4px] bg-white"
              :src="product.entity?.entity_media"
              :alt="product.entity?.entity_name || ''"
            />
            <span class="text-sm">{{ product.entity?.entity_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </BaseLocaleLink>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { MarketplaceProduct } from '~/models/marketplace'

interface PropsInterface {
  product: MarketplaceProduct
}

const props = defineProps<PropsInterface>()

const i18n = useI18n()

const title = computed(() =>
  getFieldLocale(
    parseFieldLocales(props.product.title) || '',
    i18n.locale.value
  )
)

const shortDescription = computed(() =>
  props.product.short_description
    ? getFieldLocale(
        parseFieldLocales(props.product.short_description) || '',
        i18n.locale.value
      )
    : ''
)
</script>
